import React from 'react';
import { Retry } from '@src/components/common';
import useSelectMetric from '@src/components/widget-panel/hooks/useSelectMetric';
import { useFlowQuery } from './hooks';
import FlowEngagement from './components/Engagement';
import FlowExperience from './components/Experience';
import FlowPerformance from './components/Performance';
import * as Styled from './styled';
import type { AppFlowMetadata } from '@src/hooks/flow/useFlowConfigs';

export interface FlowProps {
  wid: string;
  flowMeta: AppFlowMetadata;
}

const Flow = ({ wid, flowMeta }: FlowProps) => {
  const query = useFlowQuery(wid, flowMeta);
  const selectMetric = useSelectMetric();

  return (
    <Retry
      progress
      isLoading={query.isFetching}
      showError={query.isError}
      fetchData={query.refetch}
      queued={query.queued}
    >
      <Styled.FlowContainer>
        <FlowEngagement data={query.staticMetricsData} />
        <FlowExperience flowMeta={flowMeta} data={query.flowData} onMetricClick={selectMetric} />
        <FlowPerformance flowMeta={flowMeta} data={query.flowData} onMetricClick={selectMetric} />
      </Styled.FlowContainer>
    </Retry>
  );
};

export default React.memo(Flow);
